import { useEffect, useState } from "react";
import { Sparkles, Palette, Rocket, Brain, Briefcase, TrendingUp, Heart } from "lucide-react";
import PublicShell from "@/components/public/PublicShell";
import LeadDialog from "@/components/public/LeadDialog";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import api from "@/lib/api";

const ICONS = { sparkles: Sparkles, palette: Palette, rocket: Rocket, brain: Brain, briefcase: Briefcase, "trending-up": TrendingUp, heart: Heart };
const GROUPS = ["Kids", "Teens", "Youth", "Professionals", "Seniors"];

export default function LearningPaths() {
    const [paths, setPaths] = useState([]);
    const [active, setActive] = useState("All");
    useEffect(() => { api.get("/learning-paths").then((r) => setPaths(r.data)).catch(() => {}); }, []);
    const shown = active === "All" ? paths : paths.filter((p) => p.group === active);

    return (
        <PublicShell>
            <section className="section-pad grid-bg">
                <div className="container-page">
                    <p className="overline">Find Your Learning Path</p>
                    <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">A path for every generation</h1>
                    <p className="mt-4 max-w-2xl text-lg text-foreground/70">From ages 5 to 50+ — practical, safe and future-ready learning designed for where you are today.</p>
                    <div className="mt-8 flex flex-wrap gap-2">
                        {["All", ...GROUPS].map((g) => (
                            <button key={g} data-testid={`path-filter-${g}`} onClick={() => setActive(g)}
                                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${active === g ? "bg-primary text-primary-foreground" : "bg-muted text-foreground/70 hover:bg-muted/70"}`}>
                                {g}
                            </button>
                        ))}
                    </div>
                </div>
            </section>
            <section className="pb-24">
                <div className="container-page grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {shown.map((p) => {
                        const Icon = ICONS[p.icon] || Sparkles;
                        return (
                            <Card key={p.id} data-testid={`path-${p.age}`} className="p-6 border-border/70 hover:border-primary hover:shadow-lg transition-all">
                                <div className="flex items-center justify-between">
                                    <span className="grid h-11 w-11 place-items-center rounded-xl bg-primary/10 text-primary"><Icon className="h-5 w-5" /></span>
                                    <span className="font-mono text-xs rounded-full border border-border px-2.5 py-1 text-foreground/60">Ages {p.age}</span>
                                </div>
                                <h3 className="mt-4 font-heading text-lg font-bold">{p.title}</h3>
                                <p className="mt-2 text-sm text-foreground/60 leading-relaxed">{p.desc}</p>
                                <LeadDialog source="program_inquiry" program={`${p.title} (Ages ${p.age})`} title={`Start: ${p.title}`}
                                    trigger={<Button variant="ghost" className="mt-3 px-0 text-primary" data-testid={`path-start-${p.age}`}>Start this path →</Button>} />
                            </Card>
                        );
                    })}
                </div>
            </section>
        </PublicShell>
    );
}
